const DISPLAY_ALERT_TYPE = 'DisplayAlert';
const SELECT_INSTITUTION_TYPE = 'SelectInstitution';

export { DISPLAY_ALERT_TYPE, SELECT_INSTITUTION_TYPE }